import { create } from 'zustand';

// ---------------------------------------------------------------------------
// Types
// ---------------------------------------------------------------------------

export type Screen = 'scanner' | 'history' | 'stats' | 'config';
export type ConnectionStatus = 'online' | 'offline';
export type ToastType = 'success' | 'error' | 'warning';

interface ToastMessage {
  text: string;
  type: ToastType;
}

interface AppState {
  screen: Screen;
  connectionStatus: ConnectionStatus;
  pendingCount: number;
  toastMessage: ToastMessage | null;

  navigate: (screen: Screen) => void;
  setOnline: () => void;
  setOffline: () => void;
  setPendingCount: (n: number) => void;
  showToast: (text: string, type: ToastType) => void;
  hideToast: () => void;
}

// ---------------------------------------------------------------------------
// Store (runtime — NOT persisted)
// ---------------------------------------------------------------------------

export const useAppStore = create<AppState>()((set) => ({
  screen: 'scanner',
  connectionStatus: 'online',
  pendingCount: 0,
  toastMessage: null,

  navigate: (screen) => set({ screen }),

  setOnline: () => set({ connectionStatus: 'online' }),

  setOffline: () => set({ connectionStatus: 'offline' }),

  setPendingCount: (n) => set({ pendingCount: n }),

  showToast: (text, type) => set({ toastMessage: { text, type } }),

  hideToast: () => set({ toastMessage: null }),
}));
